import Pipeline from "../Pipeline";
import { ISubscriber } from "../types";
import SubscriberPlugin from "./Subscriber";

import Click from "./plugins/click";
import Expose from "./plugins/expose";
import Setup from "./plugins/setup";
import Pay from "./plugins/pay";
import Stay from "./plugins/stay";
import Customize from "./plugins/customize";

type MAP_ITEM = { [K: string]: typeof SubscriberPlugin };

const SUBSCRIBER_MAP: MAP_ITEM = {
    click: Click,
    vtExpose: Expose,
    setupEvent: Setup,
    payEvent: Pay,
    stayEvent: Stay,
    customize: Customize
};

export default class Subscriber extends Pipeline<Event> implements ISubscriber {
    private plugins: { [K: string]: SubscriberPlugin } = {};

    subscribe(): void {
        Object.entries(SUBSCRIBER_MAP).forEach(([key, SB]) => {
            const sb = new SB();

            sb.on("action", (e: Event) => {
                if (e.composedPath) {
                    e["vpath"] = e.composedPath();
                }

                this.push(e);
            });

            sb.setup();

            this.plugins[key] = sb;
        });
    }

    /**
     * 动态增加元素曝光监听
     * @param {Element} el [description]
     */
    addExposeObserve(el: Element): void {
        (this.plugins["vtExpose"] as Expose).addObserve(el);
    }

    /**
     * 获取当前所有监听曝光的元素
     * @return {Array<Element>} [description]
     */
    get allObserved(): Array<Element> {
        return (this.plugins["vtExpose"] as Expose).allObserved;
    }

    process(e: Event): Event {
        return e;
    }
}
